import type React from 'react';
import type { InstanceActionStyle, InstanceActionType } from './anbox-management.types';

export const formatNumber = (value: number | undefined): string => {
  if (value === undefined) return '0';
  return new Intl.NumberFormat('en-US').format(value);
};

export const getStatusBadgeStyle = (status: string, isDark: boolean): React.CSSProperties => {
  switch (status) {
    case 'active':
    case 'available':
    case 'running':
      return { background: isDark ? '#0D2818' : '#DCFCE7', color: isDark ? '#5EE9B5' : '#15803D' };
    case 'maintenance':
    case 'stopping':
    case 'starting':
      return { background: isDark ? '#2A2008' : '#FEF9C3', color: isDark ? '#FACC15' : '#A16207' };
    case 'offline':
    case 'stopped':
      return { background: isDark ? '#1D293D' : '#F3F4F6', color: isDark ? '#90A1B9' : '#475569' };
    case 'assigned':
      return { background: isDark ? '#0C1A2E' : '#DBEAFE', color: isDark ? '#60A5FA' : '#1D4ED8' };
    case 'error':
      return { background: isDark ? '#2A1215' : '#FEE2E2', color: isDark ? '#F87171' : '#DC2626' };
    default:
      return { background: isDark ? '#1D293D' : '#F3F4F6', color: isDark ? '#90A1B9' : '#475569' };
  }
};

export const getInstanceActionStyle = (
  action: InstanceActionType,
  isDark: boolean
): InstanceActionStyle => {
  if (action === 'delete') {
    return { bg: isDark ? '#2A1215' : '#FEE2E2', iconColor: isDark ? '#F87171' : '#DC2626' };
  }
  if (action === 'release') {
    return { bg: isDark ? '#2A2008' : '#FFEDD5', iconColor: isDark ? '#FB923C' : '#EA580C' };
  }
  return { bg: isDark ? '#0C1A2E' : '#EEF2FF', iconColor: isDark ? '#818CF8' : '#4338CA' };
};
